import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-img-view',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './img-view.component.html',
  styleUrl: './img-view.component.scss'
})
export class ImgViewComponent implements OnInit {
  @Input() imageUrl: string ='';
  @Input() cssClass: string = '';
  @Input() imgAlt: string = '';
  private apiUrl = environment.apiUrl.slice(0, -4); // API URL'inizi buraya yazın
  imgUrl:string=''
  
  ngOnInit(): void {
    if(this.imageUrl == '') this.imgUrl=''
    else this.imgUrl = environment.uploadsUrl+this.imageUrl;
  }

}
